 class Modal {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('keydown', this.handleKeydown.bind(this));
      document.addEventListener('open:modal', this.handleCustomOpen.bind(this));
    }

    handleClick(e) {
      const trigger = e.target.closest('[data-modal]');
      if (trigger) {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-modal');
        this.openModal(modalId);
        return;
      }

      const closeButton = e.target.closest('[data-modal-close]');
      if (closeButton) {
        e.preventDefault();
        const modalId = closeButton.getAttribute('data-modal-close');
        this.closeModal(modalId);
        return;
      }

      const backdrop = e.target.closest('.modal-backdrop');
      if (backdrop) {
        const modal = backdrop.closest('[data-modal-container]');
        if (modal) {
          const modalId = modal.getAttribute('data-modal-container');
          this.closeModal(modalId);
        }
      }
    }

    handleKeydown(e) {
      if (e.key === 'Escape') {
        const openModal = document.querySelector('[data-modal-container]:not([style*="display: none"])');
        if (openModal) {
          const modalId = openModal.getAttribute('data-modal-container');
          this.closeModal(modalId);
        }
      }
    }

    handleCustomOpen(e) {
      if (e.detail && e.detail.modal_id) {
        this.openModal(e.detail.modal_id);
      }
    }

    openModal(modalId) {
      const modal = document.querySelector(`[data-modal-container="${modalId}"]`);
      if (modal) {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      }
    }

    closeModal(modalId) {
      const modal = document.querySelector(`[data-modal-container="${modalId}"]`);
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    new Modal();
  });